import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

/*
 * @example
 *
 *   <ShowOnly on="isPhone">
 *     ...
 *   </ShowOnly>
 *   <ShowOnly on="isTabletUp">
 *     ...
 *   </ShowOnly>
 */
export const ShowOnly = ({ on, children }) => {
  const matched = useDeviceType(on)

  return (
    matched ? children : null
  )
}
